export default "__VITE_ASSET__BxepxyWC__"